<template lang="pug">
    v-dialog(:value="true")
        v-card
            v-btn(
                @click="handleRequest()"
                :disabled="loading"
                ) Clickeame
            v-progress-circular(
                indeterminate
                v-if="loading"
                )
            span {{message}}
            
</template>

<script>
// -- Component Imports --
// -- JS Data files import --
// -- JS Libraries Import --
import axios from 'axios'
// -- Mixins imports --
// -- Vuex Imports --
// -- Other Imports --
export default {
    name: 'component-name',
    props: {
        // ------------------------- UI State ---------------------------------
        loading: false,
        message: ''
        // ------------------------- Component Data ---------------------------
    },
    data: function(){
        return {
            // ------------------------ UI State ------------------------------
            // ------------------------ Data storing --------------------------
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        // -------------------- Data fetching ---------------------------------
        handleRequest(){
            this.loading = true
            axios.get('http://192.168.0.109:3000').then(
                res => {
                    this.loading = false
                    this.message = res.data.length + 'datos'
                }
            )
        }
        // -------------------- Data handling and transformations -------------
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    // watch: {},
    // components: {},
    // mixins: [],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss">
    
</style>